import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class SelectedReportName {
    public reportName: string;
}
